/*
 * Adore Nails — theme.js
 * Vanilla, no dependencies. Wired to: gallery swap, qty stepper, variant
 * selection (Shape + Size + generic option options), and quick-buy toasts.
 */

(function () {
  'use strict';

  /* ---------- Utilities ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    // Very light INR formatter — matches ₹699 / ₹1,299 style.
    // For richer formatting the merchant can override shop.money_format.
    if (cents == null) return '';
    var rupees = Math.round(cents / 100);
    return '₹' + rupees.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function toast(message, isError) {
    var el = document.createElement('div');
    el.className = 'adore-toast' + (isError ? ' adore-toast--error' : '');
    el.textContent = message;
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.remove(); }, 300);
    }, 2600);
  }

  /* ============================================================
   * Product gallery — thumb click swaps main image
   * ============================================================ */
  function initGallery() {
    var gallery = $('[data-gallery]');
    if (!gallery) return;

    var mainImages = $$('[data-gallery-main] img', gallery);
    var thumbs = $$('[data-gallery-thumb]', gallery);

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mediaId = thumb.getAttribute('data-media-id');
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        mainImages.forEach(function (img) {
          img.classList.toggle('is-active', img.getAttribute('data-media-id') === mediaId);
        });
      });
    });
  }

  /* ============================================================
   * Quantity stepper
   * ============================================================ */
  function initQtyStepper() {
    $$('[data-qty]').forEach(function (wrap) {
      var input = $('input[type="number"]', wrap);
      if (!input) return;
      var min = parseInt(input.min || '1', 10);
      var dec = $('[data-qty-dec]', wrap);
      var inc = $('[data-qty-inc]', wrap);
      if (dec) dec.addEventListener('click', function () {
        var v = parseInt(input.value || '1', 10);
        if (v > min) { input.value = v - 1; input.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      if (inc) inc.addEventListener('click', function () {
        var v = parseInt(input.value || '1', 10);
        input.value = v + 1; input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ============================================================
   * Variant picker — Shape/Size/etc. Reads product JSON from an embedded
   * script tag and updates price + button state + selected variant id.
   * ============================================================ */
  function initVariantPicker() {
    var picker = $('[data-variant-picker]');
    if (!picker) return;

    var dataEl = $('[data-product-json]', picker) || $('[data-product-json]');
    if (!dataEl) return;

    var product;
    try { product = JSON.parse(dataEl.textContent); }
    catch (e) { console.warn('Adore: product JSON parse failed', e); return; }

    var form = picker.closest('form[action*="/cart/add"]') || $('form[action*="/cart/add"]');
    var variantIdInput = form && form.querySelector('input[name="id"]');
    var addBtn = form && form.querySelector('[data-add-to-cart]');
    var addBtnText = addBtn && addBtn.querySelector('[data-add-to-cart-text]');
    var addBtnPrice = addBtn && addBtn.querySelector('[data-add-to-cart-price]');
    var priceNow = $('[data-price-now]');
    var priceWas = $('[data-price-was]');
    var priceOff = $('[data-price-off]');

    var optionInputs = $$('.opt-input', picker);

    function selectedOptions() {
      var options = [];
      product.options.forEach(function (name, i) {
        var checked = picker.querySelector('.opt-input[data-option-position="' + (i + 1) + '"]:checked');
        options[i] = checked ? checked.value : null;
      });
      return options;
    }

    function findVariant(options) {
      return product.variants.find(function (v) {
        return options.every(function (val, i) { return v.options[i] === val; });
      });
    }

    function markAvailability(currentOptions) {
      // For each input, temporarily set its option value and see if any variant with
      // that combination is available. Used to grey out impossible combinations.
      optionInputs.forEach(function (input) {
        var pos = parseInt(input.getAttribute('data-option-position'), 10) - 1;
        var trial = currentOptions.slice();
        trial[pos] = input.value;
        var variant = product.variants.find(function (v) {
          return trial.every(function (val, i) { return val == null || v.options[i] === val; });
        });
        input.classList.toggle('is-unavailable', !variant || !variant.available);
      });
    }

    function update() {
      var opts = selectedOptions();
      markAvailability(opts);
      var variant = findVariant(opts);

      if (!variant) {
        if (variantIdInput) variantIdInput.value = '';
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.classList.add('is-disabled');
          if (addBtnText) addBtnText.textContent = window.Adore.strings.unavailable || 'Unavailable';
          if (addBtnPrice) addBtnPrice.textContent = '';
        }
        return;
      }

      if (variantIdInput) variantIdInput.value = variant.id;

      // Push variant id to URL for shareability
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      } catch (e) { /* noop */ }

      if (priceNow) priceNow.textContent = formatMoney(variant.price);
      if (priceWas) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWas.textContent = formatMoney(variant.compare_at_price);
          priceWas.style.display = '';
          if (priceOff) {
            var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
            priceOff.textContent = pct + '% off';
            priceOff.style.display = '';
          }
        } else {
          priceWas.textContent = '';
          priceWas.style.display = 'none';
          if (priceOff) { priceOff.textContent = ''; priceOff.style.display = 'none'; }
        }
      }

      if (addBtn) {
        var available = variant.available;
        addBtn.disabled = !available;
        addBtn.classList.toggle('is-disabled', !available);
        if (addBtnText) {
          addBtnText.textContent = available
            ? (window.Adore.strings.addToCart || 'Add to Cart')
            : (window.Adore.strings.soldOut || 'Sold out');
        }
        if (addBtnPrice) {
          addBtnPrice.textContent = available ? ' — ' + formatMoney(variant.price) : '';
        }
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', update);
    });

    update();
  }

  /* ============================================================
   * PDP add-to-cart — Ajax so the user stays on the page
   * ============================================================ */
  function initAddToCart() {
    var form = document.getElementById('ProductForm-main') || $('form[action$="/cart/add"]');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-add-to-cart]');
      var textEl = btn && btn.querySelector('[data-add-to-cart-text]');
      var originalText = textEl && textEl.textContent;
      if (btn) { btn.disabled = true; if (textEl) textEl.textContent = 'Adding…'; }

      fetch(window.Adore.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) {
            toast((res.data && res.data.description) || 'Could not add to cart.', true);
            return;
          }
          toast('Added to cart · ' + (res.data.title || ''));
          if (window.Adore && window.Adore.cart && typeof window.Adore.cart.refresh === 'function') {
            window.Adore.cart.refresh().then(function () { window.Adore.cart.open(); });
          }
        })
        .catch(function () { toast('Network error. Try again.', true); })
        .finally(function () {
          if (btn) { btn.disabled = false; if (textEl && originalText) textEl.textContent = originalText; }
        });
    });
  }

  /* ============================================================
   * Cart drawer — open/close, live re-render, qty + remove
   * ============================================================ */
  function initCartDrawer() {
    var drawer = document.getElementById('CartDrawer');
    var toggles = $$('[data-cart-toggle]');
    if (!drawer) return;

    var body = drawer.querySelector('[data-cart-body]');
    var itemsEl = drawer.querySelector('[data-cart-items]');
    var emptyEl = drawer.querySelector('[data-cart-empty]');
    var totalEl = drawer.querySelector('[data-cart-total]');
    var footerEl = drawer.querySelector('[data-cart-footer]');
    var tierWrap = drawer.querySelector('[data-cart-tier]');
    var tierFill = drawer.querySelector('[data-tier-fill]');
    var tierLede = drawer.querySelector('[data-tier-lede]');
    var nodeShip = drawer.querySelector('[data-tier-node="ship"]');
    var countEls = $$('[data-cart-count]');
    var countInline = drawer.querySelector('[data-cart-count-inline]');
    var recsWrap = drawer.querySelector('[data-cart-recs]');
    var recsTrack = drawer.querySelector('[data-cart-recs-track]');

    var FREE_SHIP = parseInt(drawer.getAttribute('data-free-ship') || '0', 10);

    function open() {
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-open');
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
      refresh();
    }
    function close() {
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-open');
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    }

    toggles.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        drawer.getAttribute('aria-hidden') === 'true' ? open() : close();
      });
    });
    $$('[data-cart-close]', drawer).forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close();
    });

    function formatINR(cents) {
      if (cents == null) return '';
      var rupees = Math.round(cents / 100);
      return '₹' + rupees.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function renderLine(item) {
      var img = item.image
        ? '<img src="' + item.image.replace(/\.(jpg|jpeg|png|webp)/, '_240x.$1') + '" alt="' + (item.product_title || '') + '" loading="lazy">'
        : '';
      var variantTitle = (item.variant_title && item.variant_title.indexOf('Default') === -1)
        ? '<div class="cart-line__variant">' + item.variant_title + '</div>'
        : '';
      var priceWas = (item.original_line_price > item.final_line_price)
        ? '<span class="cart-line__price-was">' + formatINR(item.original_line_price) + '</span>'
        : '';
      return '' +
        '<article class="cart-line" data-cart-line data-key="' + item.key + '">' +
          '<a href="' + item.url + '" class="cart-line__media" tabindex="-1">' + img + '</a>' +
          '<div class="cart-line__body">' +
            '<a href="' + item.url + '" class="cart-line__title">' + item.product_title + '</a>' +
            variantTitle +
            '<div class="cart-line__price">' +
              '<span class="cart-line__price-now">' + formatINR(item.final_line_price) + '</span>' +
              priceWas +
            '</div>' +
            '<div class="cart-line__row">' +
              '<div class="cart-line__qty" data-cart-qty>' +
                '<button type="button" class="cart-line__qty-btn" data-qty-dec aria-label="Decrease quantity">−</button>' +
                '<input type="number" class="cart-line__qty-input" value="' + item.quantity + '" min="0" data-qty-input aria-label="Quantity">' +
                '<button type="button" class="cart-line__qty-btn" data-qty-inc aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<button type="button" class="cart-line__remove" data-cart-remove aria-label="Remove item">' +
                '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M6 6l1 14a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-14"/></svg>' +
              '</button>' +
            '</div>' +
          '</div>' +
        '</article>';
    }

    function updateTier(totalCents) {
      var totalRupees = Math.round(totalCents / 100);
      if (!tierWrap || !FREE_SHIP) return;
      var pct = Math.min(100, Math.round((totalRupees / FREE_SHIP) * 100));
      if (tierFill) tierFill.style.width = pct + '%';
      if (nodeShip) nodeShip.classList.toggle('is-reached', totalRupees >= FREE_SHIP);
      if (tierLede) {
        if (totalRupees >= FREE_SHIP) {
          tierLede.innerHTML = '<strong>Congrats!</strong> You unlocked free shipping.';
        } else {
          var toShip = FREE_SHIP - totalRupees;
          tierLede.innerHTML = 'Add <strong>₹' + toShip.toLocaleString('en-IN') + '</strong> to unlock free shipping';
        }
      }
    }

    function fetchRecommendations(cart) {
      if (!recsWrap || !recsTrack) return;
      var items = cart.items || [];
      if (items.length === 0) {
        recsWrap.hidden = true;
        return;
      }
      var seed = items[items.length - 1].product_id;
      var cartIds = items.map(function (i) { return i.product_id; });
      var url = '/recommendations/products.json?product_id=' + seed + '&limit=8&intent=related';
      fetch(url, { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.products || []).filter(function (p) { return cartIds.indexOf(p.id) === -1; }).slice(0, 4);
          if (products.length === 0) { recsWrap.hidden = true; return; }
          recsTrack.innerHTML = products.map(function (p) {
            var img = (p.featured_image || (p.images && p.images[0])) || '';
            var imgSrc = img ? img.replace(/(\.(jpg|jpeg|png|webp))/i, '_240x$1') : '';
            var price = formatINR(p.price);
            var firstVariantId = p.variants && p.variants[0] && p.variants[0].id;
            return '' +
              '<div class="cart-rec" data-cart-rec>' +
                '<a href="' + p.url + '" class="cart-rec__media" tabindex="-1">' +
                  (imgSrc ? '<img src="' + imgSrc + '" alt="' + (p.title || '') + '" loading="lazy">' : '') +
                '</a>' +
                '<div class="cart-rec__body">' +
                  '<a href="' + p.url + '" class="cart-rec__title">' + p.title + '</a>' +
                  '<div class="cart-rec__price">' + price + '</div>' +
                '</div>' +
                (firstVariantId
                  ? '<button type="button" class="cart-rec__add" data-cart-rec-add data-variant-id="' + firstVariantId + '" aria-label="Add ' + (p.title || '') + '">+</button>'
                  : '') +
              '</div>';
          }).join('');
          recsWrap.hidden = false;
        })
        .catch(function () { recsWrap.hidden = true; });
    }

    function render(cart) {
      var count = cart.item_count || 0;
      countEls.forEach(function (el) {
        el.textContent = count;
        el.setAttribute('aria-hidden', count === 0 ? 'true' : 'false');
      });
      if (countInline) countInline.textContent = '(' + count + ')';

      if (count === 0) {
        if (itemsEl) itemsEl.innerHTML = '';
        if (emptyEl) emptyEl.hidden = false;
        if (footerEl) footerEl.hidden = true;
        if (tierWrap) tierWrap.hidden = true;
        return;
      }

      if (emptyEl) emptyEl.hidden = true;
      if (footerEl) footerEl.hidden = false;
      if (tierWrap) tierWrap.hidden = false;

      if (itemsEl) {
        itemsEl.innerHTML = (cart.items || []).map(renderLine).join('');
      }
      if (totalEl) totalEl.textContent = formatINR(cart.total_price);
      updateTier(cart.total_price);
      fetchRecommendations(cart);
    }

    function refresh() {
      return fetch(window.Adore.routes.cart_url + '.js', {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (r) { return r.json(); })
        .then(function (data) { render(data); return data; })
        .catch(function () { /* keep server-rendered state */ });
    }

    function changeQty(key, quantity) {
      return fetch(window.Adore.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) { render(data); return data; })
        .catch(function () { toast('Could not update cart. Try again.', true); });
    }

    itemsEl && itemsEl.addEventListener('click', function (e) {
      var line = e.target.closest('[data-cart-line]');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var input = line.querySelector('[data-qty-input]');
      var qty = input ? parseInt(input.value || '1', 10) : 1;

      if (e.target.closest('[data-qty-dec]')) {
        changeQty(key, Math.max(0, qty - 1));
      } else if (e.target.closest('[data-qty-inc]')) {
        changeQty(key, qty + 1);
      } else if (e.target.closest('[data-cart-remove]')) {
        changeQty(key, 0);
      }
    });

    itemsEl && itemsEl.addEventListener('change', function (e) {
      if (!e.target.matches('[data-qty-input]')) return;
      var line = e.target.closest('[data-cart-line]');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var qty = Math.max(0, parseInt(e.target.value || '0', 10));
      changeQty(key, qty);
    });

    recsTrack && recsTrack.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart-rec-add]');
      if (!btn) return;
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      var originalLabel = btn.textContent;
      btn.disabled = true;
      btn.textContent = '…';
      fetch(window.Adore.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) {
            toast((res.data && res.data.description) || 'Could not add.', true);
            return;
          }
          refresh();
        })
        .catch(function () { toast('Network error. Try again.', true); })
        .finally(function () { btn.disabled = false; btn.textContent = originalLabel; });
    });

    window.Adore = window.Adore || {};
    window.Adore.cart = { open: open, close: close, refresh: refresh };

    refresh();
  }

  /* ============================================================
   * FAQ / accordion — already native <details>, no JS needed.
   * But: close others on open when data-accordion-exclusive is set.
   * ============================================================ */
  function initAccordions() {
    $$('[data-accordion-exclusive]').forEach(function (group) {
      var items = $$('details', group);
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) items.forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
        });
      });
    });
  }

  /* ============================================================
   * Marquee — duplicate content so translation loops seamlessly.
   * ============================================================ */
  function initMarquee() {
    $$('[data-marquee]').forEach(function (m) {
      var track = m.querySelector('.area-track');
      if (!track) return;
      var clone = track.innerHTML;
      track.innerHTML = clone + clone;
    });
  }

  /* ============================================================
   * Insta reels — ensure each video autoplays on mount and pauses
   * when the whole section leaves the viewport (saves battery).
   * ============================================================ */
  function initInstaReels() {
    var videos = $$('.insta-reel-video');
    if (!videos.length) return;

    videos.forEach(function (v) {
      v.muted = true;
      v.setAttribute('playsinline', '');
      var attempt = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      attempt();
      v.addEventListener('canplay', attempt, { once: true });
    });

    if ('IntersectionObserver' in window) {
      var band = $('.insta-reels-band');
      if (!band) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var action = entry.isIntersecting ? 'play' : 'pause';
          videos.forEach(function (v) {
            try { v[action](); } catch (e) {}
          });
        });
      }, { threshold: 0.05 });
      io.observe(band);
    }
  }

  /* ============================================================
   * Drag-to-scroll — for horizontal card rails (reviews, reels)
   * marked with [data-manual-scroll]. Touch works natively; this
   * adds mouse click+drag on desktop.
   * ============================================================ */
  function initManualScroll() {
    $$('[data-manual-scroll]').forEach(function (band) {
      var isDown = false, startX = 0, startScroll = 0, moved = false;
      band.addEventListener('mousedown', function (e) {
        isDown = true; moved = false;
        startX = e.pageX - band.offsetLeft;
        startScroll = band.scrollLeft;
        band.classList.add('is-dragging');
      });
      band.addEventListener('mouseleave', function () { isDown = false; band.classList.remove('is-dragging'); });
      band.addEventListener('mouseup', function () { isDown = false; band.classList.remove('is-dragging'); });
      band.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        var x = e.pageX - band.offsetLeft;
        var walk = (x - startX);
        if (Math.abs(walk) > 4) moved = true;
        band.scrollLeft = startScroll - walk;
      });
      // Prevent link navigation after a drag
      band.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
    });
  }

  /* ============================================================
   * Auto-linkify wa.me/tel URLs in rich-text on Pages + Policies.
   * Merchant edits paste plain-text URLs; make them clickable.
   * ============================================================ */
  function initAutoLink() {
    var scopes = document.querySelectorAll('.page-doc .rte, .shopify-policy__body .rte, .shopify-policy__container');
    if (!scopes.length) return;
    var URL_RE = /(https?:\/\/[^\s<>"']+|wa\.me\/[^\s<>"'()]+)/g;
    function processNode(node) {
      if (node.nodeType === 3) {
        var txt = node.nodeValue;
        if (!URL_RE.test(txt)) return;
        URL_RE.lastIndex = 0;
        var frag = document.createDocumentFragment();
        var lastIdx = 0, m;
        while ((m = URL_RE.exec(txt))) {
          if (m.index > lastIdx) frag.appendChild(document.createTextNode(txt.slice(lastIdx, m.index)));
          var a = document.createElement('a');
          var href = m[0].indexOf('http') === 0 ? m[0] : ('https://' + m[0]);
          a.href = href; a.target = '_blank'; a.rel = 'noopener'; a.textContent = m[0];
          frag.appendChild(a);
          lastIdx = m.index + m[0].length;
        }
        if (lastIdx < txt.length) frag.appendChild(document.createTextNode(txt.slice(lastIdx)));
        node.parentNode.replaceChild(frag, node);
      } else if (node.nodeType === 1 && node.nodeName !== 'A' && node.nodeName !== 'SCRIPT' && node.nodeName !== 'STYLE') {
        Array.prototype.slice.call(node.childNodes).forEach(processNode);
      }
    }
    scopes.forEach(function (s) { processNode(s); });
  }

  /* ============================================================
   * DOM ready
   * ============================================================ */
  document.addEventListener('DOMContentLoaded', function () {
    initGallery();
    initQtyStepper();
    initVariantPicker();
    initAddToCart();
    initAccordions();
    initMarquee();
    initInstaReels();
    initCartDrawer();
    initCartPageAutoUpdate();
    initManualScroll();
    initAutoLink();
  });

  /* ============================================================
   * Cart page — auto-update on qty change, no Update button needed
   * ============================================================ */
  function initCartPageAutoUpdate() {
    var page = document.querySelector('.cart-page');
    if (!page) return;
    var subtotalEl = page.querySelector('[data-cart-page-subtotal]');
    var countEls = $$('[data-cart-count]');

    function formatINR(cents) {
      if (cents == null) return '';
      var rupees = Math.round(cents / 100);
      return '₹' + rupees.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function updateRow(row, item) {
      var totalEl = row.querySelector('[data-cart-page-line-total]');
      if (totalEl) totalEl.textContent = formatINR(item.final_line_price);
      var qtyInput = row.querySelector('input[type="number"]');
      if (qtyInput) qtyInput.value = item.quantity;
    }

    function refreshTotals(data) {
      if (subtotalEl) subtotalEl.textContent = formatINR(data.total_price);
      countEls.forEach(function (el) {
        el.textContent = data.item_count;
        el.setAttribute('aria-hidden', data.item_count === 0 ? 'true' : 'false');
      });
      if (data.item_count === 0) window.location.reload();
    }

    function change(key, qty, row) {
      row && row.classList.add('is-loading');
      fetch(window.Adore.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          refreshTotals(data);
          if (qty === 0 && row) { row.remove(); return; }
          if (row) {
            var updated = (data.items || []).find(function (it) { return it.key === key; });
            if (updated) updateRow(row, updated);
          }
          if (window.Adore && window.Adore.cart) window.Adore.cart.refresh();
        })
        .catch(function () { toast('Could not update cart.', true); })
        .finally(function () { row && row.classList.remove('is-loading'); });
    }

    page.addEventListener('click', function (e) {
      var row = e.target.closest('[data-cart-item]');
      if (!row) return;
      var input = row.querySelector('input[type="number"]');
      var key = row.getAttribute('data-cart-item');
      if (!input || !key) return;
      var qty = parseInt(input.value || '1', 10);
      if (e.target.closest('[data-qty-dec]')) {
        change(key, Math.max(0, qty - 1), row);
      } else if (e.target.closest('[data-qty-inc]')) {
        change(key, qty + 1, row);
      } else if (e.target.closest('[data-cart-page-remove]')) {
        change(key, 0, row);
      }
    });

    page.addEventListener('change', function (e) {
      if (e.target.tagName !== 'INPUT' || e.target.type !== 'number') return;
      var row = e.target.closest('[data-cart-item]');
      if (!row) return;
      var key = row.getAttribute('data-cart-item');
      var qty = Math.max(0, parseInt(e.target.value || '0', 10));
      change(key, qty, row);
    });
  }
})();
